import locale from 'live/init/global-locale'
import i18n from 'live/services/i18n'
import LoggerFactory from 'live/services/logger'
import serviceLocator from 'live/services/service-locator'

import { IUpdateModeFrontPresenter, UpdateModeFrontAPI } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'
import { IBarrier } from 'plugin-codaf-risk-ext-bowtie/types'

import { enUS, ptBR } from './i18n'
import { QualitativeLopaScaling } from './updateMode/QualitativeLopaScaling'

export const logger = LoggerFactory('plugin-qualitative-lopa-scaling-dra-engine')

type IUpdateModeJsonConfigConfig = {
    degradationContribution: number | string
}

const locales = { pt_br: ptBR, en_us: enUS }
i18n.add(locales[locale ?? 'en_us'])

function requestValidationArray(barrier: IBarrier): string[] {
    const errorsArray: string[] = []

    if(!barrier.escalations.length){
        errorsArray.push(i18n("escalation factor"))
    }
    barrier.escalations.forEach((escalation, index)=>{
        const degradationContribution = 
        (escalation.updateModeJsonConfig as IUpdateModeJsonConfigConfig)?.degradationContribution
        if(degradationContribution === null 
            || degradationContribution === undefined
            || degradationContribution< 0
            || degradationContribution>100 ){
                errorsArray.push(` ${i18n('escalation')} #${index+1} ${i18n('must have degradation contribution between 0 and 100')} `)
            }
    })

    return errorsArray
}




const qualitativeLopaScalingPresenter: IUpdateModeFrontPresenter = {
    label: 'Qualitative Lopa Scaling',
    method: 'QUALITATIVE',
    component: QualitativeLopaScaling,
    updateModeCode: 'qualitative_lopa_scaling',
    validationFunction: requestValidationArray
}

serviceLocator.getService('dra:updatemodefrontservice').then((updateModeFrontAPI: unknown) => {
    try {
        (updateModeFrontAPI as UpdateModeFrontAPI).addUpdateModeFrontPresenter(qualitativeLopaScalingPresenter)
        logger.info('front sucesseful registered to DRA engines')
    } catch (e) {
        logger.error(e)
    }
})
